import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@mui/material';

export default function ImportFailureNotice({ lifecycle }) {
    const diagnostic = lifecycle?.diagnostic;
    // Review starts only after the checks finish. An earlier retry diagnostic
    // is historical evidence, not the current status of this paused operation.
    if (lifecycle?.phase === 'removal_review') return null;
    if (lifecycle?.status === 'running' && diagnostic?.code === 'watchlist_operation_market_data_pending') {
        return <Alert severity="info">Checking the data needed for this Watchlist update…</Alert>;
    }
    if (!['running', 'failed'].includes(lifecycle?.status)
        || typeof diagnostic?.message !== 'string' || !diagnostic.message) return null;
    return (
        <Alert severity={lifecycle.status === 'failed' ? 'error' : 'warning'}>
            {diagnostic.message}
            {lifecycle.status === 'failed'
                ? ` ${diagnostic.retryable ? 'Trying again may help.' : 'Trying again with the same request is unlikely to help.'}`
                : diagnostic.retryable && ' The import is retrying automatically.'}
            {typeof diagnostic.code === 'string' && ` Code: ${diagnostic.code}.`}
            {typeof diagnostic.reference === 'string' && ` Reference: ${diagnostic.reference}.`}
        </Alert>
    );
}

ImportFailureNotice.propTypes = { lifecycle: PropTypes.object };
